import { Box, Typography, Skeleton } from "@mui/material";
import React from "react";

type KPISummaryCardProps = {
  title: string;
  value: string;
  subtitle?: string;
  icon?: React.ReactNode;
  iconBg?: string;
  loading?: boolean;
};

export const KPISummaryCard = ({
  title,
  value,
  subtitle,
  icon,
  iconBg,
  loading,
}: KPISummaryCardProps) => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "20px",
        border: "1px solid #EAEAEA",
        height: "160px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "8px",
        boxShadow: "0px 0px 4px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#1E1E1E",
          }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            backgroundColor: iconBg || "#F5F7FB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      </Box>

      <Box>
        {loading ? (
          <Skeleton variant="text" width={100} height={40} />
        ) : (
          <>
            <Typography
              sx={{ fontSize: "22px", fontWeight: 700, lineHeight: 1.2 }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontSize: "13px", color: "#6B7280", mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};
